const form = $('.page-id-20401 form');
let settings;

const init = ( s = false ) => {

    if (s) {
        settings = s;
    }

    registerEvents();
    trackRelatedPostLinks();
};

const getCheckboxStates = (form) => {
    let checkboxes = form.find('input[type=checkbox]');
    let result = {};
    let name;

    for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].value === 'WP0iWal3XRl7637634pL0QAowg') {
            name = '.NET newsletter';
        } else {
            name = 'Simple Talk';
        }

        result[name] = checkboxes[i].checked ? 'subscribe' : 'unsubscribe';
    }
    return result;
};

const registerEvents = () => {
    // on Sign Up page, attach event to registration form completion
    form.submit( () => {
        let checkboxes = getCheckboxStates(form);
        for (let checkbox in checkboxes) {
            if (checkboxes[checkbox] === 'subscribe') {
                settings?.analytics?.trackEvent('subscription change', {
                    action: checkboxes[checkbox],
                    checkbox: checkbox,
                    form: '/account/sign-up',
                });
            }
        }
    });
};

const trackRelatedPostLinks = () => {
    const relatedPostLinks = document.querySelectorAll('.widget_related_posts a');
    if ( ! relatedPostLinks.length ) return;

    for ( let i = 0; i < relatedPostLinks.length; i++ ) {
        const link = relatedPostLinks[i];

        link.addEventListener('click', event => {
            settings?.analytics?.trackEvent('Related post link click', {
                link: event.target.href,
                pathname: window.location.pathname,
            });
        });
    }
}

const trackEvent = ( category, action, label = null ) => {
    if ( typeof category !== 'string' && ! category.length ) {
        console.error('Category not provided');
        return false;
    }
    if ( typeof action !== 'string' && ! action.length ) {
        console.error('Action not provided');
        return false;
    }

    settings?.analytics?.trackEvent(category, {
        action,
        label,
    });
};

export default {
    init,
    getCheckboxStates,
    trackEvent,
};
